import React from "react";
import { Box, Chip } from "@mui/material";

// Extended to cover every label statusUtils.js can actually produce
// from real backend data (not just the mockup's happy-path labels).
//
// Colors verified against the Figma pixel values, not guessed:
// - Ongoing is green in the design (same family as Approved/Completed),
//   not blue — it was previously mismatched.
// - Upcoming is neutral gray (same family as Not Started), not purple —
//   it was previously mismatched.
// - On Hold appears in the design (project cards) but had no entry here
//   at all, so it was silently falling back to the default gray chip.
const statusMap = {
    Pending: {
        bg: "#FEF3C7",
        color: "#B45309",
    },
    Rejected: {
        bg: "#FEE2E2",
        color: "#DC2626",
    },
    Overdue: {
        bg: "#FEE2E2",
        color: "#DC2626",
    },
    Approved: {
        bg: "#DCFCE7",
        color: "#15803D",
    },
    Completed: {
        bg: "#DCFCE7",
        color: "#15803D",
    },
    Ongoing: {
        bg: "#DCFCE7",
        color: "#15803D",
    },
    Upcoming: {
        bg: "#F3F4F6",
        color: "#6B7280",
    },
    "In Progress": {
        bg: "#DBEAFE",
        color: "#1D4ED8",
        dot: true,
    },
    "On Hold": {
        bg: "#FEF3C7",
        color: "#B45309",
        dot: true,
    },
    "Not Started": {
        bg: "#F3F4F6",
        color: "#6B7280",
    },
    "Quiz Failed": {
        bg: "#FEE2E2",
        color: "#DC2626",
    },
    Available: {
        bg: "#DCFCE7",
        color: "#15803D",
    },
    "Under Maintenance": {
        bg: "#FEF3C7",
        color: "#B45309",
    },
    "Out of Order": {
        bg: "#FEE2E2",
        color: "#DC2626",
    },
};

export default function StatusChip({ status }) {
    const style = statusMap[status] || {
        bg: "#F3F4F6",
        color: "#6B7280",
    };

    return (
        <Chip
            size="small"
            label={
                style.dot ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <Box
                            sx={{
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                bgcolor: style.color,
                                flexShrink: 0,
                            }}
                        />
                        {status}
                    </Box>
                ) : (
                    status
                )
            }
            sx={{
                bgcolor: style.bg,
                color: style.color,
                fontWeight: 600,
                borderRadius: "8px",
            }}
        />
    );
}
